import Vuex from 'vuex'
import Vue from 'vue'
import storage from '../utils/storage'

// 安装插件
Vue.use(Vuex)

// 创建store对象
const store = new Vuex.Store({
    namespaced: true,
    // 存放数据
    state: {
        // 存储token
        Authorization: storage.get('Authorization') ? storage.get('Authorization') : '',

        // 用户信息
        USERINFO: storage.get('USERINFO') ? storage.get('USERINFO') : '',

        // 获取开放id
        OPENID: storage.get('OPENID') ? storage.get('OPENID') : '',

        // 菜单权限
        menuItem: '',

        TOKEN: null,
    },

    // 修改state中数据的一些方法
    mutations: {
        // 修改token，并将token存入localStorage
        changeLogin(state, user) {
            storage.set('Authorization', user);
            state.Authorization = user; 
        },

        // 修改用户信息
        updateUserInfo(state, data) {
            storage.set('USERINFO', data);
            state.USERINFO = data;
        },

        // 修改开放id
        updateOpenid(state, data) {
            storage.set('OPENID', data);
            state.OPENID = data;
        },

        // 修改菜单
        setMenuList(state, data) {
            state.menuItem = data
        }
    },

    // 异步方法
    actions: {
        // 修改用户信息
        async updateUserInfo(context, data) {
            context.commit('updateUserInfo', data)
        },
    },
})

export default store